import { PRODUCT_NAME } from "@/utils/global-constants";
import styles from "./logo-header.module.css";

export interface LogoHeaderProps {
  tapLogo?: () => void;
}

export default function LogoHeader({ tapLogo }: LogoHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        <button
          onClick={tapLogo || (() => {})}
          className={styles.logoButton}
          aria-label="Go to home page"
        >
          <img
            src="/images/logoSalpha.png"
            alt="Logo"
            width={6.06869 * 16}
            height={2.3125 * 16}
            className={styles.logoImage}
            style={{ width: "auto" }}
          />
          <span className={styles.productName} title="Product Name">
            .{PRODUCT_NAME}
          </span>
        </button>
      </div>
    </header>
  );
}
